<template>
    <div id="content" style="height: 100%;width: 920px;margin: 4px auto;" v-if="load">
        <div style="margin: 4px auto;">
            <el-alert :title="userInfo.config.gd" v-if="userInfo.config.gd" type="success" show-icon>
            </el-alert>
        </div>

        <div style="margin: 4px auto;" v-if="userInfo.rob">
            <el-tabs v-model="rbType" @tab-click="handleClick">
                <el-tab-pane v-for="item in userInfo.game" :key="item.id" :label="item.name" :name="item.gameType"
                    :sele="item.hasSelect">
                </el-tab-pane>
            </el-tabs>
            <div class="topframe" style="margin: 4px auto;">
                <div class="tophead">
                    欢迎您 : <b>{{userInfo.rob.UserName}}
                    </b>，机 : <b>{{userInfo.rob.tuoNum}} </b>，过期时间 : <b class="guoqitime">{{userInfo.rob.time}}
                        23:59:58</b>&nbsp;&nbsp;
                    &nbsp;&nbsp; 额度 : <b><span id="leftScore">{{userInfo.rob.score}}</span>
                    </b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:;" @click="logout">退出登录</a>
                    <div class="topheadmenu" @click="centerDialogVisible = true"><span>修改密码</span></div>
                </div>

                <div class="main">
                    <div class="leftBox">
                        <div id="codelogin">
                            <div class="logininp" v-if="userInfo.config" v-html="userInfo.config.rbMsg">
                            </div>
                            <div style="margin: 5px;" v-if="hasSelect == 1 && userInfo.rob.qh == 1">
                                <hr style="margin: 8px 0;">
                                可用球位:
                                <div style="padding-left: 2px;">
                                    <el-checkbox-group v-model="checkList">
                                        <el-checkbox label="1"></el-checkbox>
                                        <el-checkbox label="2"></el-checkbox>
                                        <el-checkbox label="3"></el-checkbox>
                                        <el-checkbox label="4"></el-checkbox>
                                        <el-checkbox label="5"></el-checkbox>
                                        <el-checkbox label="6"></el-checkbox>
                                        <el-checkbox label="7"></el-checkbox>
                                        <el-checkbox label="8"></el-checkbox>
                                    </el-checkbox-group>
                                    <el-button size="small" type="primary" @click="setQiuNum()"
                                        style="padding: 5px 11px;height: 24px;">更新</el-button>
                                </div>
                            </div>
                        </div>
                        <div id="xiazhuban">
                            <div class="xiazhutitle"><b>下注榜：</b><span id="dangqianzhuqi"
                                    title="">{{userInfo.qihao}}期&nbsp;&nbsp;(<span
                                        style='color:green;font-weight:bolder;'>普:{{userInfo.total1}}</span>,托:{{userInfo.total2}},吃:{{userInfo.total3}})</span><br><button
                                    class="loginwxbtn" :class="rbcmdType==0||!rbcmdType?'selBtn':''" style="width:75px;"
                                    id="btnShowPuCmd"
                                    @click="pushText(0, 'xiazhulist')">普(<span>{{userInfo.totalPu}}</span>)</button>&nbsp;&nbsp;<button
                                    class="loginwxbtn" :class="rbcmdType==1?'selBtn':''" style="width:75px;"
                                    id="btnShowTuoCmd"
                                    @click="pushText(1, 'xiazhulist')">托(<span>{{userInfo.totalTuo}}</span>)</button>&nbsp;&nbsp;<button
                                    class="loginwxbtn" :class="rbcmdType==2?'selBtn':''" style="width:75px;"
                                    id="btnShowTuoCmd2"
                                    @click="pushText(2, 'xiazhulist')">吃单(<span>{{userInfo.totalChi}}</span>)</button>
                            </div>
                            <div id="xiazhubanlist" style="border-radius: 0 0 10px 10px;height:445px;overflow-y: auto;">
                                <div v-for="(item,index) in userInfo.detail" :key="item.id"
                                    :class="index % 2 == 0 ?'se':''">
                                    <b
                                        :class="'status' + item.flyers_status">●</b><span>[{{item.wid}}]“{{item.text}}”合计：{{item.score}}</span><s
                                        @click="delCmd(item)">×</s>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class=" rightframe">
                        <div class="right_top" style="display: flex;align-items: center;">
                            <div><span class="kaipanstatustit"
                                    :class="userInfo.rob.isOpen==1?' sed':''">当前状态：</span><button id="kaipanstatus"
                                    style="visibility: visible;color:#409eff;border-color:#a0cfff;background:#ecf5ff;"
                                    @click="open">{{userInfo.rob.isOpen==1?'开盘':'收盘'}}</button>
                            </div>
                            <div class="peilv" style="top:4px;position: initial;"><b>赔率：</b><input class="ok"
                                    style="width: 60px; height: 25px;" v-model="userInfo.rob.PeiLv"
                                    @blur="setT('PeiLv',userInfo.rob.PeiLv)" @focus="isInput=true"
                                    :readonly="userInfo.rob.xiugai==1?false:true">
                                <span style="color:blue;right: 80px;top: 10px;margin-left: 5px;cursor: pointer;"
                                    @click="showXian" v-if="userInfo.rob.xiugai==1">限额和赔率</span>
                            </div>
                            <input id="selefocus" type="text" readonly="readonly">
                            <div class="peilv2" style="width:120px;right:150px;display: none;">
                                <b>特码赔率：</b><input class="ok" data-type="tePeilv" v-model="userInfo.rob.tePeilv">
                            </div>
                            <div class="fanshuiSet2" style="width:120px;right:10px;display: none;">
                                <b>特码返水：</b><input class="ok" data-type="teFanshui" v-model="userInfo.rob.teFanshui">
                            </div>
                            <div style="width: 230px;margin-left: 10px;">
                                <div class="score" style="display: flex;right: 95px;float:left;">
                                    流水显示：
                                    <div><label for="liushui"><input id="liushui" type="radio" name="ls" value="0"
                                                style="width:20px;" :checked="userInfo.rob.ls==0?'checked':''"
                                                @change="setT('ls',0)">不限</label> <label for="liushui"><input
                                                id="liushui" type="radio" name="ls" value="1" style="width:20px;"
                                                :checked="userInfo.rob.ls==1?'checked':''"
                                                @change="setT('ls',1)">单边</label> <label for="liushuis"><input
                                                id="liushuis" type="radio" name="ls" value="2" style="width:20px;"
                                                :checked="userInfo.rob.ls==2?'checked':''"
                                                @change="setT('ls',2)">双边</label></div>
                                </div>
                                <div class="score"
                                    style="display: flex;right: 95px;float:left;margin-left:0px;display: none;">
                                    <b>倒计时：</b>
                                    <div><label for="daoji"><input id="daoji" type="radio" name="dj" value="1"
                                                style="width:20px;">开</label> <label for="daojin"><input id="daojin"
                                                type="radio" name="dj" value="2" style="width:20px;">关</label>
                                    </div>
                                </div>
                                <div class="score" style="display: flex;float:left;right: 95px;margin-left:0px;">
                                    会员订单：
                                    <div><label for="vip"><input id="vip" type="radio" name="vip" value="1"
                                                style="width:20px;" :checked="userInfo.rob.vip==1?'checked':''"
                                                @change="setT('vip',1)">显示</label> <label for="vipn"><input id="vipn"
                                                type="radio" name="vip" value="2" style="width:20px;"
                                                :checked="userInfo.rob.vip==2?'checked':''"
                                                @change="setT('vip',2)">不显示</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="functions" style="border-radius: 10px;border:none;padding:0;">
                            <div class="functions" style="display:flex;align-items:center;">
                                <div class="yuliufengpan">(预留封盘：5分盘)&nbsp;<input class="ok"
                                        style="width: 48px; height: 25px;" id="yuliufengpan5"
                                        v-model="userInfo.rob.fengpan" @focus="isInput=true"
                                        @blur="setT('fengpan',userInfo.rob.fengpan)"
                                        :readonly="userInfo.rob.xiugai==1?false:true">秒)&nbsp;(延报<input class="ok"
                                        style="width: 48px; height: 25px;" id="edtCancel" v-model="userInfo.rob.delay"
                                        @focus="isInput=true" @blur="setT('delay',userInfo.rob.delay)"
                                        :readonly="userInfo.rob.xiugai==1?false:true">秒)
                                    (返水<input class="ok" style="width: 48px; height: 25px;"
                                        v-model="userInfo.rob.FanShui" @focus="isInput=true"
                                        @blur="setT('FanShui',userInfo.rob.FanShui)"
                                        :readonly="userInfo.rob.xiugai==1?false:true">)
                                    <div class="score"
                                        style="float: right;display: none;margin-right: 8px;margin-top: 4px;">
                                        开奖：前三位相加</div>
                                    <div class="score"
                                        style="display: flex;float: right;margin-right: 20px;margin-top: 4px;display: none;">
                                        会员订单：
                                        <div><label for="vip"><input id="vip" type="radio" name="vip" value="1"
                                                    style="width:20px;">是</label> <label for="vipn"><input id="vipn"
                                                    type="radio" name="vip" value="2" style="width:20px;">否</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="functions"
                                style="border-left: 0px; border-right: 0px; border-bottom: 0px; display: flex;">
                                <div> 房间域名：
                                    <select id="chatDomains" @change="setD" v-model="userInfo.rob.url">
                                        <option v-for="(item,index) in userInfo.config.yuming" :key="index"
                                            :value="index">
                                            {{item}}
                                        </option>
                                    </select>
                                </div>
                                <div style="padding-left: 10px; display: flex; line-height: 22px;display: none;">
                                    开放注册：
                                    <label for="log"><input id="log" type="radio" name="log" value="1"
                                            style="width:20px;">是</label> <label for="logn"><input id="logn"
                                            type="radio" name="log" value="2" style="width:20px;">否</label>
                                </div>
                            </div>

                            <div style="padding: 0px 0px 5px 5px;display: none;"> 登录链接：<a :href="userInfo.rob.link"
                                    style="color: black; padding-right: 10px;">userInfo.rob.link</a><a
                                    href="javascript:;" class="copyLoginLink">复制链接</a></div>

                            <div class="sxf" style="height:165px;border:none;border-top: 1px solid #000">
                                <div class="sxftitle" style="display: flex;">
                                    <b class="shangxiafentit red">上下分确认：</b><button id="baojingbtn"
                                        style="height: 22px;padding: 0 8px;font-size: 12px;margin-bottom: 3px;"
                                        @click="baojing()">测试提示音</button>
                                    <div class="score"
                                        style="display: flex;right: 95px;top: 10px;margin-left: 125px;display: none;">
                                        提示音：
                                        <div><label for="danbian"><input id="danbian" type="radio" name="ltype"
                                                    value="1" style="width:20px;">声音1</label> <label
                                                for="shuangbian"><input id="shuangbian" type="radio" name="ltype"
                                                    value="2" style="width:20px;">声音2</label></div>
                                    </div>
                                </div>
                                <div class="sxflist" style="height:80%;overflow-y: auto;">
                                    <div v-for="(item,index) in userInfo.list" :key="item.id" class="sxfitem"
                                        :class="(index % 2 == 1)?'aid'+item.id+' se':'aid'+item.id"><span
                                            class="content">{{"@" + item.nickName + "：" + (item.type == 0 ? "上分 +" : "下分 -") + parseFloat(item.score) + " (" + item.gname + ")"}}</span>
                                        <div class="sxfbtns"><span class="ld"></span><span class="ty"
                                                @click="ty(item,1,index)">同意</span><span class="qx"
                                                @click="ty(item,0,index)">取消</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="jifen" style="height:480px;border:none;">
                                <div class="jifentitle"><b>积分榜：</b><button id="baojingbtn"
                                        style="display:none;">报警</button><span id="baojingmsg"
                                        class="red"></span><button class="loginwxbtn" :class="rbuserType==0?'selBtn':''"
                                        style="width:75px;" id="btnShowPu"
                                        @click="pushText(0, 'userlist')">普(<span>{{userInfo.count1}}</span>)</button>&nbsp;&nbsp;<button
                                        class="loginwxbtn" :class="rbuserType==1?'selBtn':''" style="width:75px;"
                                        id="btnShowTuo"
                                        @click="pushText(1, 'userlist')">托(<span>{{userInfo.count2}}</span>)</button>&nbsp;&nbsp;<button
                                        class="refjifen" @click="refreshData()">刷新积分排序</button> &nbsp;&nbsp;<a
                                        href="javascript:;" @click="goRecord">积分记录</a>&nbsp;&nbsp;<a
                                        href="{:url('index/ShowUnCalculated')}" target="_self"
                                        style="display:none;">未结指令</a></div>
                                <p
                                    style="margin-top: 15px;text-align: right;padding-right: 60px;width: 320px;color: #000;font-weight: bolder;">
                                    合计：<span id="heji">{{userInfo.heji}}</span></p>
                                <input name="search" type="text" placeholder="请输入用户用户名" class="search"
                                    style="width: 300px;line-height: 20px !important;margin-top: 0px;"
                                    v-model="searchVal" @input="search()">
                                <div class="jifenleftlist"
                                    style="height:calc(100% - 105px);overflow-y: auto;width:320px;">
                                    <div style="display:flex;justify-content: space-between;"
                                        v-for="(item,index) in userInfo.data" :key="index" @click="selectUser(item)"><b
                                            class="black"
                                            :style="item.isBlack == 1?'width: 16px;':'width: 16px;background: none;'"
                                            v-if="item.isrobot == 0">{{item.isBlack == 1?'黑':''}}</b><b class="zhui"
                                            style="display: none;">{{item.zhui == 1?'追':''}}</b><b class="fake"
                                            :style="item.chi == 1?'display:block;':'display:block;background: none;width: 16px;'"
                                            v-if="item.isrobot == 0">{{item.chi == 1?'吃':''}}</b><i
                                            :class="item.isauto == 0 && item.isrobot == 1?'t':'h'"
                                            v-if="item.isrobot == 1"
                                            @click.stop="zd(item,index)">{{item.isauto == 0 && item.isrobot == 1?'手动':'自动'}}</i><b
                                            class="nick"
                                            style="width:180px;text-align:left;margin-left:2px;">{{"@v" + item.id + '.' + item.NickName.substr(0, 8)}}</b><span>{{item.score}}</span><s
                                            style="margin-left:0;width:35px;" @click="delUser(item)">删除</s></div>
                                </div>
                                <div class="jifenright" style="height:calc(100% - 45px);width:255px;">
                                    <img :src="user.imgName?'https://'+ $store.state.baseUrl + user.imgName:'https://'+ $store.state.baseUrl + '/static/xz/admin/defaultheadimg.jpg'"
                                        @click="headImg()" class="avatar headimg" title="点击随机更改头像"
                                        style="width: 66px;height: 66px;right: 5px;"
                                        :style="{'top': (user.isrobot==1?'140': '180')+'px'}">
                                    <button class="create_real" style="right:95px;" @click="addUser(1)">创建托</button>
                                    <button class="create_real" style="right:5px;" @click="addUser(0)">创建会员</button>
                                    <div style="margin-top: 8px;margin-bottom: 8px;"><b>修改积分</b></div>
                                    <div class="usernumber">会员ID：{{user.id}}</div>
                                    <div class="nickname" style="display: flex;align-items: center;">
                                        昵&nbsp;&nbsp;&nbsp;&nbsp;称：<input id="NickName"
                                            style="width: 130px;border: 1px solid #888;border-radius: 5px;"
                                            v-model="user.NickName"><button class="setnick" v-if="user.id"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;"
                                            @click="updateU('NickName')">更新</button>
                                    </div>
                                    <div class="nickname userName" style="display: flex;align-items: center;">
                                        备&nbsp;&nbsp;&nbsp;&nbsp;注：<input id="userName"
                                            style="width: 130px;border: 1px solid #888;border-radius: 5px;"
                                            v-model="user.UserName" placeholder="备注"><button class="setname"
                                            v-if="user.id"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;"
                                            @click="updateU('UserName')">更新</button>
                                    </div>
                                    <div class="nickname userPwd" style="display: flex;display: none;">
                                        密&nbsp;&nbsp;&nbsp;&nbsp;码：<input id="userPwd"
                                            style="width: 110px;border: 1px solid #888;border-radius: 5px;"><button
                                            class="setpwd"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;">更新</button>
                                    </div>
                                    <div class="nickname loginPwd" style="display: flex;" v-if="userInfo.rob.yzm==1">
                                        验证码：<input id="loginPwd" v-model="user.logincode"
                                            style="width: 85px;border: 1px solid #888;border-radius: 5px;"><button
                                            class="setpwd2"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;"
                                            v-if="user.id" @click="copyCode()">复制</button><button class="setpwd2"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;"
                                            v-if="user.id" @click="updateU('logincode')">更新</button>
                                    </div>
                                    <div style="margin-top:10px;margin-bottom: 0;" v-if="user.id&&user.isrobot==0">
                                        <button class="repwd"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;display: none;">重置密码</button><button
                                            class="setblack" v-if="user.isBlack==0" @click="updateU('isBlack',1)"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;">拉黑</button><button
                                            class="setblack" v-else @click="updateU('isBlack',0)"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;">拉白</button><button
                                            class="setmanual2" v-if="user.chi==0&&userInfo.rob.xiugai==1"
                                            @click="updateU('chi',1)"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;">
                                            吃</button><button class="setmanual2"
                                            v-if="user.chi==1&&userInfo.rob.xiugai==1" @click="updateU('chi',0)"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;">不吃</button>
                                    </div>
                                    <div class="score" style="margin-top: 10px;">
                                        积&nbsp;&nbsp;&nbsp;&nbsp;分：{{user.score}}</div>
                                    <div><input name="changejifenval" v-model="updown"></div>
                                    <div style="margin-top:0;"><button class="submitjifen"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;"
                                            @click="upscore(1)">上分</button><button class="submitjifen2"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:8px;margin-bottom: 5px;"
                                            @click="upscore(2)">下分</button>
                                        <button class="setmanual" v-if="user.isauto==1&&user.isrobot==1"
                                            @click="updateU('isauto',0)"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;margin-bottom: 5px;">改手动</button><button
                                            class="setmanual" v-if="user.isauto==0&&user.isrobot==1"
                                            @click="updateU('isauto',1)"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;margin-bottom: 5px;">改自动</button>
                                        <button class="setzhui myHide" data-type="1"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;margin-bottom: 5px;">开通追</button><button
                                            class="setzhui myHide" data-type="0"
                                            style="font-size: 12px;padding: 5px 9px;height: 26px;margin-left:5px;">关闭追</button><br />
                                        <el-button size="mini" style="margin-left:5px;padding: 5px 9px;"
                                            v-if="user.link" @click="copy()">复制链接</el-button>
                                        <el-popover placement="top" width="300" trigger="click">
                                            <el-alert :title="user.link" type="success"
                                                style="margin-top: 5px;word-break: break-all;" :closable="false">
                                                <a href="javascript:;" style="color: black;"
                                                    @click="refresh()">[刷新链接]</a>
                                            </el-alert>
                                            <div style="text-align: center; padding: 5px 0px; height: 240px;">
                                                <img :src="user.qr" height="100%">
                                            </div>
                                            <div style="text-align: center; padding: 5px 0px;">
                                                <el-button type="primary" size="mini"
                                                    style="margin-left:5px;padding: 5px 9px;"
                                                    @click="copy()">复制链接</el-button>
                                                <el-button type="primary" size="mini"
                                                    style="margin-left:5px;padding: 5px 9px;"
                                                    @click="copyQr()">复制二维码</el-button>
                                            </div>
                                            <el-button slot="reference" size="mini"
                                                style="margin-left:5px;padding: 5px 9px;"
                                                v-if="user.link">链接二维码</el-button>
                                        </el-popover>
                                        <el-button size="mini" style="margin-left:5px;padding: 5px 9px;"
                                            v-if="user.link" @click="refresh()">刷新链接</el-button>
                                    </div>
                                    <div class="flyers_num" v-if="user.isrobot == 1">
                                        <span>下注范围：</span>
                                        <el-select v-model="user.tuoMinMax" placeholder="请选择" size="mini"
                                            @change="setN">
                                            <el-option label="30-300" value="30-300"></el-option>
                                            <el-option label="100-1000" value="100-1000"></el-option>
                                            <el-option label="1000-6000" value="1000-6000"></el-option>
                                            <el-option label="3000-9000" value="3000-9000"></el-option>
                                        </el-select>
                                    </div>
                                    <el-alert v-if="user.link" :title="user.link" type="success"
                                        style="padding: 5px 5px 0px;word-break: break-all;" :closable="false">
                                    </el-alert>
                                    <div class="jifenmessage"></div>
                                </div>
                            </div>

                            <div id="wangpan" class="flyers">
                                <div class="" style="padding: 10px; height: auto;">
                                    <div class="el-row"
                                        style="margin-left: -2.5px; margin-right: -2.5px;align-items:center;display: flex;">
                                        <div
                                            style="padding-right: 2.5px;padding-left: 2.5px;align-items: center;display: flex;">
                                            报网类型:&nbsp;<span class="wptype"
                                                v-if="userInfo.iswp==1">{{userInfo.Data.wpname||'无'}}</span>&nbsp;<el-button
                                                size="small" @click="setWp()"
                                                style="height: 28px;color: #409EFF;">设置账号(0)</el-button></div>
                                        <div style="padding-right: 2.5px; padding-left: 2.5px;text-align:left;"
                                            v-if="userInfo.iswp==1">
                                            &nbsp;&nbsp;&nbsp;&nbsp;<el-button size="small" type="success"
                                                @click="wpLogin()">开始报网</el-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;网盘余额:
                                            <span class="pankouMoney">{{userInfo.Data.money}}</span>
                                        </div>
                                    </div>
                                    <div class="el-row wpinfo" v-if="userInfo.iswp==1"
                                        style="margin-left: -2.5px; margin-right: -2.5px; padding-top: 5px;align-items:center;display: flex;">
                                        <div
                                            style="padding-right: 2.5px; padding-left: 2.5px;align-items: center;display: flex;justify-content: space-between;">
                                            报网状态: <span class="flyers_tips">{{userInfo.Data.text}}</span>
                                            <label style="padding-right: 34px;margin-left: 90px;display: flex;"><input
                                                    type="checkbox" id="flyers_withdraw"
                                                    style="height: 20px;width: 20px;margin-right: 5px;"
                                                    :checked="userInfo.Data.flyers_withdraw==1?true:false"
                                                    @change="changeFly('flyers_withdraw',userInfo.Data.flyers_withdraw==1?0:1)">
                                                失败自动退单
                                            </label>
                                        </div>
                                        <div style="padding-right: 2.5px; padding-left: 2.5px;"> 超时订单:
                                            <span style="display: inline-block; min-width: 20px;"
                                                class="csrecord">0</span>
                                            押注: <span style="display: inline-block; min-width: 20px;"
                                                class="pankouYa">{{userInfo.Data.betting}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="userInfo.config">
            <audio id="sfaudio" style="width:0px;height:0px;" preload="auto">
                <source id="sxfsysf" :src="'https://'+ $store.state.baseUrl + '/mp3/886.mp3'">
            </audio>
            <audio id="xfaudio" style="width:0px;height:0px;" preload="auto">
                <source id="sxfsyxf" :src="'https://'+ $store.state.baseUrl + '/mp3/qq.aac'">
            </audio>
            <audio id="alertaudio" style="width:0px;height:0px;display:none;" preload="auto">
                <source id="baojing" :src="'https://'+ $store.state.baseUrl + '/static/xz/admin/alert.mp3'">
            </audio>
        </div>
        <el-dialog title="" :visible.sync="centerDialogVisible" center :show-close="false">
            <div style="padding: 20px;">
                <el-divider content-position="center">更新密码</el-divider>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="旧密码" prop="oldPwd">
                        <el-input v-model="ruleForm.oldPwd" type="password" autocomplete="off" show-password></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="newPwd">
                        <el-input v-model="ruleForm.newPwd" type="password" autocomplete="off" show-password></el-input>
                    </el-form-item>
                    <el-form-item label="确认新密码" prop="renewPwd">
                        <el-input v-model="ruleForm.renewPwd" type="password" autocomplete="off"
                            show-password></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button style="line-height: 0;" type="primary" @click="changePwd()">确认</el-button>
                        <el-button style="line-height: 0;" @click="centerDialogVisible = false">关闭</el-button>
                    </el-form-item>
                </el-form>
                <el-divider content-position="center">更新子密码</el-divider>
                <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="子密码" prop="subPwd">
                        <el-input v-model="ruleForm2.subPwd" type="password" autocomplete="off"
                            show-password></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button style="line-height: 0;" type="primary" @click="changeSubPwd()">确认</el-button>
                        <el-button style="line-height: 0;" @click="centerDialogVisible = false">关闭</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        <el-dialog :title="gname+'-报网配置'" :visible.sync="wpVisible" center @close="wpVisible = false;isInput = false;"
            v-if="userInfo.Data">
            <div>
                <div class="tip custom-block">
                    <p class="custom-block-title">请注意</p>
                    <p>1.当添加多个报网账号时，系统是自动选择网盘余额最大的那个进行报网。</p>
                </div>
                <el-form :model="userInfo.Data" :rules="rules" ref="ruleForm" label-width="85px" class="demo-ruleForm">
                    <el-form-item label="网盘" prop="fly_id" required>
                        <el-radio-group v-model="userInfo.Data.fly_id">
                            <el-radio v-for="(item,index) in wpList" :key="index"
                                :label="item.id">{{item.name}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="报网方式" prop="flyers_type" required>
                        <el-radio-group v-model="userInfo.Data.flyers_type">
                            <el-radio label="1">直报</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="报网分组" prop="fly_fs" required>
                        <el-radio-group v-model="userInfo.Data.fly_fs">
                            <el-radio label="1">单边</el-radio>
                            <el-radio label="2">双边</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="取消报网失败的订单" prop="flyers_withdraw">
                        <el-switch v-model="userInfo.Data.flyers_withdraw" active-value='1'
                            inactive-value='0'></el-switch>
                    </el-form-item>
                    <el-form-item label="报网账号" prop="desc">
                        <el-button type="primary" size="small" @click.prevent="addFly()">添加报网账号</el-button>
                    </el-form-item>
                    <el-table :data="tableData" style="width: 100%">
                        <el-table-column label="用户名" width="140">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.flyers_username"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="密码" width="140">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.flyers_password"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="余额">
                            <template slot-scope="scope">
                                {{scope.row.money}}
                            </template>
                        </el-table-column>
                        <el-table-column label="启用报网">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.flyers_online" active-value="1" inactive-value="0"
                                    @change="wplog(scope.row)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column label="账号状态">
                            <template slot-scope="scope">
                                {{scope.row.msg}}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger" @click="handleDelete(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="wpVisible = false;isInput = false;">取 消</el-button>
                <el-button type="primary" @click="flySave">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="'限额和赔率'" :visible.sync="xianVisible" center @close="xianVisible = false;isInput = false;">
            <div>
                <el-form :model="xianForm" ref="xianForm" label-width="140px" class="demo-xianForm" v-if="rbType!=28">
                    <el-form-item label="玩家最高注额" prop="zuigao">
                        <el-input v-model="xianForm.zuigao"></el-input>
                    </el-form-item>
                    <el-form-item label="玩家最小注额" prop="zuidi">
                        <el-input v-model="xianForm.zuidi"></el-input>
                    </el-form-item>
                    <el-form-item label="特指令单场限额" prop="te">
                        <el-input v-model="xianForm.te"></el-input>
                    </el-form-item>
                    <el-form-item label="特指令赔率" prop="tePeilv">
                        <el-input v-model="xianForm.tePeilv"></el-input>
                    </el-form-item>
                    <el-form-item label="单场总限额" prop="pt">
                        <el-input v-model="xianForm.pt"></el-input>
                    </el-form-item>
                    <el-form-item label="单场单玩家限额" prop="total">
                        <el-input v-model="xianForm.total"></el-input>
                    </el-form-item>
                    <el-form-item label="大单场总限额" prop="daxiao">
                        <el-input v-model="xianForm.daxiao"></el-input>
                    </el-form-item>
                    <el-form-item label="小单场总限额" prop="xiao">
                        <el-input v-model="xianForm.xiao"></el-input>
                    </el-form-item>
                    <el-form-item label="单单场总限额" prop="danshuang">
                        <el-input v-model="xianForm.danshuang"></el-input>
                    </el-form-item>
                    <el-form-item label="双单场总限额" prop="shuang">
                        <el-input v-model="xianForm.shuang"></el-input>
                    </el-form-item>
                    <el-form-item label="车单场总限额" prop="che">
                        <el-input v-model="xianForm.che"></el-input>
                    </el-form-item>
                    <el-form-item label="念/严单场总限额" prop="nian">
                        <el-input v-model="xianForm.nian"></el-input>
                    </el-form-item>
                    <el-form-item label="通单场总限额" prop="tong">
                        <el-input v-model="xianForm.tong"></el-input>
                    </el-form-item>
                    <el-form-item label="加单场总限额" prop="jia">
                        <el-input v-model="xianForm.jia"></el-input>
                    </el-form-item>
                    <el-form-item label="正/堂单场总限额" prop="zheng">
                        <el-input v-model="xianForm.zheng"></el-input>
                    </el-form-item>
                    <el-form-item label="角单场总限额" prop="jiao">
                        <el-input v-model="xianForm.jiao"></el-input>
                    </el-form-item>
                    <el-form-item label="番单场总限额" prop="fan">
                        <el-input v-model="xianForm.fan"></el-input>
                    </el-form-item>
                    <el-form-item label="大单单场总限额" prop="dadan">
                        <el-input v-model="xianForm.dadan"></el-input>
                    </el-form-item>
                    <el-form-item label="大双单场总限额" prop="dashuang">
                        <el-input v-model="xianForm.dashuang"></el-input>
                    </el-form-item>
                    <el-form-item label="小单单场总限额" prop="xiaodan">
                        <el-input v-model="xianForm.xiaodan"></el-input>
                    </el-form-item>
                    <el-form-item label="小双单场总限额" prop="xiaoshaung">
                        <el-input v-model="xianForm.xiaoshaung"></el-input>
                    </el-form-item>
                </el-form>
                <el-form :model="xianForm" ref="xianForm" label-width="140px" class="demo-xianForm" v-else>
                    <el-form-item label="玩家最高注额" prop="zuigao">
                        <el-input v-model="xianForm.zuigao"></el-input>
                    </el-form-item>
                    <el-form-item label="玩家最小注额" prop="zuidi">
                        <el-input v-model="xianForm.zuidi"></el-input>
                    </el-form-item>
                    <el-form-item label="特指令单场限额" prop="te">
                        <el-input v-model="xianForm.te"></el-input>
                    </el-form-item>
                    <el-form-item label="特指令赔率" prop="tePeilv">
                        <el-input v-model="xianForm.tePeilv"></el-input>
                    </el-form-item>
                    <el-form-item label="单场总限额" prop="pt">
                        <el-input v-model="xianForm.pt"></el-input>
                    </el-form-item>
                    <el-form-item label="单场单玩家限额" prop="total">
                        <el-input v-model="xianForm.total"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="大单场总限额" prop="daxiao">
                        <el-input v-model="xianForm.daxiao"></el-input>
                    </el-form-item>
                    <el-form-item label="小单场总限额" prop="xiao">
                        <el-input v-model="xianForm.xiao"></el-input>
                    </el-form-item>
                    <el-form-item label="单单场总限额" prop="danshuang">
                        <el-input v-model="xianForm.danshuang"></el-input>
                    </el-form-item> -->
                    <el-form-item label="大小单双单限额" prop="shuang">
                        <el-input v-model="xianForm.shuang"></el-input>
                    </el-form-item>
                    <el-form-item label="1位单场总限额" prop="che">
                        <el-input v-model="xianForm.che"></el-input>
                    </el-form-item>
                    <el-form-item label="12位单场总限额" prop="nian">
                        <el-input v-model="xianForm.nian"></el-input>
                    </el-form-item>
                    <el-form-item label="123位单场总限额" prop="tong">
                        <el-input v-model="xianForm.tong"></el-input>
                    </el-form-item>
                    <el-form-item label="1定单场总限额" prop="jia">
                        <el-input v-model="xianForm.jia"></el-input>
                    </el-form-item>
                    <el-form-item label="12定单场总限额" prop="zheng">
                        <el-input v-model="xianForm.zheng"></el-input>
                    </el-form-item>
                    <el-form-item label="123定单场总限额" prop="jiao">
                        <el-input v-model="xianForm.jiao"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="xianVisible = false;isInput = false;">取 消</el-button>
                <el-button type="primary" @click="xianSave">确 定</el-button>
            </span>
        </el-dialog>
    </div>
    <div id="loader-wrapper" v-else>
        <div id="loader"></div>
        <div class="loader-section section-left"></div>
        <div class="loader-section section-right"></div>
        <div class="load_title">{{title}}</div>
    </div>
</template>

<script>
    var ws = null,
        that = null,
        isShow = true,
        timer = null,
        audio = null,
        loading = null;
    import {
        checkData
    } from '@/api/home'
    export default {
        name: 'HomePage',
        data() {
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入确认新密码'));
                } else if (value !== this.ruleForm.newPwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                gname: '',
                rbuserType: '',
                rbcmdType: '',
                rbType: '',
                tableData: [],
                recordIndex: 2,
                ruleForm: {
                    oldPwd: '',
                    newPwd: '',
                    renewPwd: '',
                    flyers_withdraw: 0,
                    fly_fs: '',
                    fly_id: '',
                    flyers_type: ''
                },
                ruleForm2: {
                    subPwd: ''
                },
                xianForm: {
                    zuigao: '',
                    zuidi: '',
                    te: '',
                    tePeilv: '',
                    pt: '',
                    total: '',
                    daxiao: '',
                    xiao: '',
                    danshuang: '',
                    shuang: '',
                    che: '',
                    nian: '',
                    tong: '',
                    jia: '',
                    zheng: '',
                    jiao: '',
                    fan: '',
                    dadan: '',
                    dashuang: '',
                    xiaodan: '',
                    xiaoshaung: ''
                },
                rules: {
                    oldPwd: [{
                        required: true,
                        message: '旧密码不能为空',
                        trigger: 'blur'
                    }],
                    newPwd: [{
                        required: true,
                        message: '新密码不能为空',
                        trigger: 'blur'
                    }],
                    renewPwd: [{
                        validator: validatePass2,
                        trigger: 'blur'
                    }]
                },
                rules2: {
                    subPwd: [{
                        required: true,
                        message: '子密码不能为空',
                        trigger: 'blur'
                    }]
                },
                searchVal: '',
                isInput: false,
                load: false,
                centerDialogVisible: false,
                recordVisible: false,
                title: '正在加载应用，请耐心等待',
                host: this.$store.state.baseUrl,
                userInfo: {},
                user: {},
                isLoad: false,
                value: '',
                radio: '17',
                game: [],
                isShow: true,
                updown: 0,
                visible: false,
                timeType: 1,
                recordList: [],
                recordDtlIndex: 0,
                recordTyIndex: 1,
                wpVisible: false,
                recordTitle: '当前积分对账',
                wpList: [],
                canPlay: true,
                updownIndex: null,
                isDone: true,
                checkList: [],
                hasSelect: 0,
                xianVisible: false
            }
        },
        // 在创建组件实例后执行
        created() {
            that = this;
            this.getInfo();
        },
        beforeDestroy() {
            isShow = false;
            ws.close();
        },
        methods: {
            showXian() {
                this.isInput = true;
                this.xianVisible = true;
            },
            xianSave() {
                ws.send(JSON.stringify({
                    "type": 'xianS',
                    "list": this.xianForm
                }));
                this.isInput = false;
                this.xianVisible = false;
            },
            addFly() {
                this.tableData.push({
                    flyers_password: '',
                    flyers_username: '',
                    msg: '未登录',
                    flyers_online: 0,
                    money: 0
                })
            },
            flySave() {
                ws.send(JSON.stringify({
                    "type": 'flyS',
                    "info": this.userInfo.Data,
                    "list": this.tableData
                }));
                this.isInput = false;
                this.wpVisible = false;
            },
            changeFly(type, data) {
                ws.send(JSON.stringify({
                    "type": 'changeF',
                    "tar": type,
                    "id": this.userInfo.rob.UserName,
                    "data": data
                }));
            },
            handleDelete(index) {
                if (this.userInfo.Data.id) {
                    ws.send(JSON.stringify({
                        "type": 'flyD',
                        "id": this.userInfo.Data.id
                    }));
                }
                this.tableData.splice(index);
            },
            wplog(row) {
                if (row.flyers_online == '1') {
                    this.wpLogin();
                }
            },
            wpLogin() {
                ws.send(JSON.stringify({
                    "type": 'wpLog'
                }));
            },
            setWp() {
                this.wpVisible = true;
                ws.send(JSON.stringify({
                    "type": 'wpList'
                }));
                this.isInput = true;
                this.tableData = [];
                if (this.userInfo.iswp) {
                    this.tableData.push({
                        flyers_password: this.userInfo.Data.flyers_password,
                        flyers_username: this.userInfo.Data.flyers_username,
                        msg: this.userInfo.Data.msg,
                        flyers_online: this.userInfo.Data.flyers_online ? '1' : '0',
                        money: this.userInfo.Data.money
                    });
                } else {
                    this.userInfo.Data = {
                        flyers_withdraw: 0,
                        fly_fs: '',
                        fly_id: 0,
                        flyers_type: ''
                    };
                }
            },
            async getInfo() {
                var uu = window.localStorage.getItem('rbToken');
                if (!uu) {
                    that.toLog();
                } else {
                    const data = await checkData(uu);
                    this.load = true;
                    if (data.status == 200) {
                        this.userInfo = data;
                        this.rbType = data.rob.type;
                        this.gname = data.gname;
                        this.rbuserType = data.rbuserType;
                        this.rbcmdType = data.rbcmdType;
                        this.checkList = data.qiuNum;
                        this.hasSelect = data.thisgame.hasSelect;
                        Object.keys(this.xianForm).forEach(key => {
                            this.xianForm[key] = data.rob[key];
                        });
                        this.initWS();
                    } else {
                        that.toLog();
                    }
                }
            },
            login(data) {
                if (isShow) {
                    this.$confirm(data.message, '系统提示', {
                        confirmButtonText: '重新登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        that.toLog();
                    }).catch(() => {
                        that.getInfo();
                    });
                }
            },
            delCmd(item) {
                if (item.status == 0 || item.status == 3) {
                    this.$confirm('是否取消此订单', '系统提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        ws.send(JSON.stringify({
                            "id": item.id,
                            "type": 'delCmd'
                        }));
                    }).catch(() => {});
                }
            },
            pushText(data, type) {
                if (type == 'xiazhulist') {
                    this.rbcmdType = data;
                } else {
                    this.rbuserType = data;
                }
                that.isDone = false;
                ws.send(JSON.stringify({
                    "data": data,
                    "type": type
                }));
            },
            ty(item, type, index) {
                loading = this.$loading({
                    lock: true,
                    text: '操作中，请等候',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                ws.send(JSON.stringify({
                    "type": 'userupdown',
                    "ReqID": item.id,
                    "uptype": type
                }));
                this.updownIndex = index;
            },
            setT(type, data) {
                ws.send(JSON.stringify({
                    "type": 'upRb',
                    "id": that.userInfo.rob.id,
                    "gameType": that.userInfo.rob.type,
                    "tar": type,
                    "data": data
                }));
                this.isInput = false;
            },
            setD(e) {
                this.userInfo.rob.url = e.target.value;
                this.setT('url', e.target.value);
            },
            setN(e) {
                this.user.tuoMinMax = e;
                ws.send(JSON.stringify({
                    "type": 'mm',
                    "id": that.user.id,
                    "data": e
                }));
            },
            open() {
                this.setT('isOpen', (this.userInfo.rob.isOpen == 1 ? 0 : 1));
            },
            goRecord() {
                this.$router.push('/mobile/oldStat');
            },
            upscore(type) {
                if (!this.user.id) {
                    that.$message.error('请先选择用户');
                } else {
                    ws.send(JSON.stringify({
                        "type": 'updown',
                        "uptype": type,
                        "id": this.user.id,
                        "count": this.updown,
                        "qh": this.userInfo.qihao
                    }));
                    this.user.score = Number(this.user.score) + Number((type == 1 ? this.updown : -this.updown));
                    this.updown = 0;
                }
            },
            headImg() {
                if (!this.user.id) {
                    that.$message.error('请先选择用户');
                } else {
                    this.$confirm('是否更新用户头像', '系统提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        ws.send(JSON.stringify({
                            "type": 'headImg',
                            "id": that.user.id
                        }));
                    }).catch(() => {});
                }
            },
            updateU(type, data) {
                if (!this.user.id) {
                    that.$message.error('请先选择用户');
                } else {
                    var val = (data == 1 || data == 0) ? data : that.user[type];
                    ws.send(JSON.stringify({
                        "type": 'upUser',
                        "id": that.user.id,
                        "tar": type,
                        "data": val
                    }));
                    that.user[type] = val;
                }
            },
            baojing() {
                audio = document.getElementById("xfaudio");
                try {
                    if (that.canPlay) {
                        audio.currenttime = 0;
                        audio.load();
                        var promise = audio.play();
                        promise.then(function() {
                            that.canPlay = false;
                        }).catch(error => console.error('播放失败', error));
                        audio.addEventListener('ended', function() {
                            that.canPlay = true;
                        });
                    }
                } catch (error) {
                    console.error('捕获到错误', error);
                }
            },
            search() {
                ws.send(JSON.stringify({
                    "type": 'searchUser',
                    "data": this.searchVal
                }));
            },
            delUser(item) {
                this.$confirm('是否删除' + item.NickName, '系统提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    ws.send(JSON.stringify({
                        "type": 'delUser',
                        "id": item.id
                    }));
                }).catch(() => {});
            },
            addUser(type) {
                ws.send(JSON.stringify({
                    "type": 'addUser',
                    "data": type
                }));
            },
            selectUser(item) {
                this.user = item;
            },
            zd(item, index) {
                var val = (item.isauto == 0 ? 1 : 0);
                ws.send(JSON.stringify({
                    "type": 'upUser',
                    "id": item.id,
                    "tar": 'isauto',
                    "data": val
                }));
                this.userInfo.data[index]['isauto'] = val;
            },
            copy() {
                navigator.clipboard.writeText(this.user.link).then(() => {
                    this.$message({
                        message: '已复制到剪贴板',
                        type: 'success'
                    });
                });
            },
            copyQr() {
                navigator.clipboard.write(this.user.qr).then(() => {
                    this.$message({
                        message: '长按二维码进行复制',
                        type: 'success'
                    });
                });
            },
            copyCode() {
                navigator.clipboard.writeText(this.user.logincode).then(() => {
                    this.$message({
                        message: '已复制到剪贴板',
                        type: 'success'
                    });
                });
            },
            refresh() {
                ws.send(JSON.stringify({
                    "type": 'refresh',
                    "id": this.user.id
                }));
            },
            toLog() {
                clearInterval(timer);
                isShow = false;
                window.localStorage.setItem('rbToken', '')
                this.$router.replace('/login');
            },
            logout() {
                this.$confirm('你确定要退出房间管理吗', '系统提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    ws.send(JSON.stringify({
                        "type": 'logout'
                    }));
                    that.toLog();
                }).catch(() => {});
            },
            handleClick(tab, event) {
                ws.send(JSON.stringify({
                    "data": tab.name,
                    "type": 'changeGame'
                }));
                this.rbType = tab.name;
                this.gname = tab.label;
                this.hasSelect = tab.$attrs.sele;
            },
            changePwd() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        ws.send(JSON.stringify({
                            "type": 'pwd',
                            "id": that.userInfo.rob.id,
                            "tar": 'password',
                            "data": this.ruleForm.newPwd,
                            "oldPwd": this.ruleForm.oldPwd,
                            "gameType": that.userInfo.rob.type
                        }));
                    }
                });
            },
            changeSubPwd() {
                this.$refs['ruleForm2'].validate((valid) => {
                    if (valid) {
                        ws.send(JSON.stringify({
                            "type": 'subPwd',
                            "id": that.userInfo.rob.id,
                            "tar": 'subpassword',
                            "data": this.ruleForm2.subPwd,
                            "gameType": that.userInfo.rob.type
                        }));
                    }
                });
            },
            refreshData() {
                if (ws) {
                    ws.send(JSON.stringify({
                        "type": 'getData'
                    }));
                    that.isDone = false;
                }
            },
            setQiuNum() {
                ws.send(JSON.stringify({
                    "id": this.userInfo.rob.id,
                    "tar": 'qiuNum',
                    "data": this.checkList.sort((a, b) => a - b),
                    "type": 'changeQiu',
                    "gameType": this.userInfo.rob.type,
                }));
            },
            initWS() {
                ws = new WebSocket("wss://" + this.host + "/wsr6?uid=" + this.userInfo.rob.id);
                ws.onopen = function() {
                    console.log("WebSocket connected.");
                    // timer = setInterval(() => {
                    that.refreshData();
                    // }, 1000);
                };
                ws.onmessage = function(event) {
                    var list = JSON.parse(event.data);
                    if (list.wstype == 'changeGame') {
                        that.checkList = list.message ? list.message.split(",") : [];
                    } else if (list.wstype == 'userupdown') {
                        if (list.status == 200) {
                            that.$message({
                                message: list.message,
                                type: 'success'
                            });
                            that.userInfo.list.splice(that.updownIndex, 1);
                        } else {
                            that.$message.error(list.message);
                        }
                        loading.close();
                    } else if (list.wstype == 'headImg') {
                        if (list.img) {
                            that.user.imgName = list.img;
                        }
                    } else if (list.rob) {
                        var uu = window.localStorage.getItem('rbToken');
                        if (list.rob.token != uu && that.isShow) {
                            that.isShow = false;
                            // ws.close();
                            that.login(list);
                        } else {
                            if (!that.isInput) {
                                that.userInfo = list;
                                if (list.list.length > 0) {
                                    that.baojing();
                                }
                                Object.keys(that.xianForm).forEach(key => {
                                    that.xianForm[key] = list.rob[key];
                                });
                            }
                            setTimeout(() => {
                                that.refreshData();
                            }, 500);
                        }
                    } else if (list.wstype == 'upUser') {
                        that.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        that.user = list.message;
                    } else if (list.wstype == 'searchUser') {
                        that.userInfo.data = list.data;
                        that.userInfo.heji = list.heji;
                    } else if (list.wstype == 'pwd' || list.wstype == 'subPwd' || list.wstype == 'delCmd' || list
                        .wstype == 'updown' || list.wstype == 'wpLog' || list.wstype == 'addUser') {
                        if (list.status == 200) {
                            that.$message({
                                message: list.message,
                                type: 'success'
                            });
                        } else {
                            that.$message.error(list.message);
                        }
                        that.centerDialogVisible = false;
                    } else if (list.wstype == 'refresh') {
                        that.user.link = list.link;
                        that.user.qr = list.qr;
                    } else if (list.wstype == 'getHis') {
                        that.isLoad = false;
                        that.recordList = list.message;
                    } else if (list.wstype == 'getHisDtl') {
                        that.isLoad = false;
                        that.recordList.detail[that.recordDtlIndex]['list'] = list.message;
                    } else if (list.wstype == 'getWay2' || list.wstype == 'getWay3' || list.wstype == 'getWay4') {
                        that.isLoad = false;
                        that.recordList = list.message;
                    } else if (list.wstype == 'wpList') {
                        that.wpList = list.message;
                    } else if (list.wstype == 'userlist') {
                        that.userInfo.data = list.message.data;
                        that.userInfo.heji = list.message.heji;
                    } else if (list.wstype == 'xiazhulist') {
                        that.userInfo.detail = list.message;
                    }
                    that.isDone = true;
                };
                ws.onclose = function() {
                    // clearInterval(timer);
                    if (isShow) {
                        that.initWS();
                    }
                    console.log("WebSocket closed.");
                };
            }
        }
    }
</script>

<style>
    button {
        cursor: pointer;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 10px;
        -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
        -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
        text-shadow: 0 1px 1px rgba(0, 0, 0, .3);
        box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
        line-height: 0 !important;
    }

    .myTuo {
        background: red;
        color: yellow;
    }

    .myHide {
        display: none;
    }

    .myShow {
        display: inline;
    }

    .red {
        color: red;
    }

    .redbg {
        background: red;
        color: #fff;
    }

    #codelogin {
        display: none;
        width: 300px;
        height: 350px;
        border: 1px solid #000;
        position: absolute;
        top: 30px;
        left: 10px;
        background: #fff;
        z-index: 1000;
        border-radius: 10px;
    }

    #codelogin .logininp {
        position: absolute;
        top: 5px;
        left: 5px;
        width: 290px;
        height: 290px;
        background: #fbfbfb;
    }

    #codelogin .logininp input {
        width: 150px;
    }

    .selBtn {
        background-color: cadetblue;
        color: yellow;
    }

    #codelogin .logininp button.loginwxbtn {
        width: 80px;
        height: 40px;
        position: absolute;
        top: 22px;
        right: 5px;
    }

    #codelogin .wxsendsmscodeval {
        width: 60px !important;
    }

    #codelogin .wxsendsmscode {
        display: none;
    }

    #codelogin .logininp .wxmsg {
        color: red;
        word-wrap: break-word;
        width: 100%;
        height: 130px;
    }

    #codelogin .logininp b {
        color: red;
    }

    #codelogin .smdl {
        padding: 5px;
    }

    #codelogin .ewm {
        text-align: center;
    }

    #codelogin img {
        width: 290px;
        height: 290px;
        margin: 5px auto;
    }

    #wangpan {
        border: 1px solid #000;
        position: absolute;
        right: 5px;
        bottom: 5px;
        height: 100px;
        padding: 5px;
        width: 560px;
        border-radius: 10px;
    }

    .functions {
        border: 1px solid #000;
        padding: 5px;
    }

    .functions label {
        cursor: pointer;
    }

    input.inpchangeval {
        width: 40px;
        text-align: center;
        color: #fff;
    }

    input.inpchangeval.change {
        background: darkorange;
    }

    input.inpchangeval.ok {
        background: #0f5717;
    }

    .wangpanselect label {
        cursor: pointer;
    }

    #wangpan .yzm s {
        position: absolute;
        display: block;
        top: 0px;
        left: 65px;
        width: 90px;
        height: 20px;
        background: #f2f2f2;
    }

    #wangpan .yzm s img {
        display: block;
        cursor: pointer;
        width: 90px;
        height: 20px;
    }

    #wangpan .yzm input {
        width: 60px;
        margin-left: 165px !important;
    }

    #xiazhuban {
        border: 1px solid #000;
        position: absolute;
        left: 10px;
        bottom: 5px;
        height: 400px;
        width: 300px;
        border-radius: 10px;
        background: #fbfbfb;
    }

    #xiazhuban .xiazhutitle {
        margin: 5px;
    }

    #xiazhubanlist {
        border: 1px solid #000;
        height: 335px;
        overflow-y: scroll;
        padding: 0px;
    }

    #xiazhubanlist {
        padding: 0 5px;
        background: #fff;
    }

    #xiazhubanlist div b.status0 {
        color: #d5f3f7;
    }

    #xiazhubanlist div b.status1 {
        color: darkorange;
        cursor: pointer;
    }

    #xiazhubanlist div b.status2 {
        color: green;
    }

    #xiazhubanlist div b.status3 {
        color: red;
        cursor: pointer;
    }

    #xiazhubanlist div.se {
        background: #f5f5f5;
    }

    #xiazhubanlist div:hover {
        background: #d5f3f7 !important;
    }

    #xiazhubanlist div {
        position: relative;
    }

    #xiazhubanlist div s {
        position: absolute;
        color: red;
        top: 0px;
        right: 0px;
        cursor: pointer;
        text-decoration: none;
        font-weight: bold;
    }

    #dangqianzhuqi {
        font-size: 12px;
    }

    #selectqun {
        display: none;
        width: 300px;
        border: 1px solid #000;
        overflow-y: hidden;
        position: absolute;
        top: 30px;
        left: 10px;
        background: #fff;
        z-index: 100;
        border-radius: 10px;
    }

    #selectqun .tit {
        color: red;
    }

    #selectqun .changewx {
        position: absolute;
        top: 0px;
        right: 0px;
        text-align: right;
    }

    #selectqun .tit.sed {
        color: #000 !important;
    }

    #selectqun #nowqun {
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        padding-left: 5px;
        background: #fbfbfb;
    }

    #selectqun #nowqun span {
        color: green;
    }

    #selectqunlist {
        margin-top: 5px;
        height: 230px;
        overflow-y: scroll;
    }

    #refquninfo {
        margin: 5px;
    }

    #selectqunlist div {
        background: #f2f2f2;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
    }

    #selectqunlist div.sele {
        background: #0f5717 !important;
        color: #fff !important;
    }

    #selectqunlist div:hover {
        background: #808080;
        color: #fff;
    }

    .topframe {
        width: 900px;
        height: 800px;
        border: 2px solid #000;
        margin: 2px auto;
        position: relative;
        border-radius: 10px;
        background: #fefefe;
    }

    #kaipanstatus {
        visibility: hidden;
    }

    .kaipanstatustit {
        color: red;
        font-weight: bolder;
    }

    .kaipanstatustit.sed {
        color: #000 !important;
    }

    .shangxiafentit.sed {
        color: red !important;
    }

    .scoremm {
        position: absolute;
        right: 200px;
        top: 5px;
        z-index: 1;
    }

    .tophead {
        padding: 5px;
        position: relative;
        font-size: 13px;
    }

    .topheadmenu {
        position: absolute;
        right: 5px;
        top: 5px;
        z-index: 1;
    }

    .topheadmenu span {
        font-weight: bold;
        color: darkgreen;
        cursor: pointer;
    }

    .divchangepwd {
        position: absolute;
        right: 5px;
        top: 0;
        border: 1px solid #000;
        border-radius: 10px;
        padding: 0 10px;
        z-index: 2;
        background: #fff;
        display: none;
    }

    .divchangepwd input {
        width: 50px;
    }

    .rightframe {
        position: absolute;
        right: 5px;
        top: 30px;
        width: 570px;
        border: 1px solid #000;
        border-radius: 10px;
    }

    .right_top {
        padding: 5px;
        position: relative;
    }

    .yuliufengpan input {
        width: 40px;
        text-align: center;
        color: #fff;
    }

    .yuliufengpan input.change {
        background: darkorange;
    }

    .yuliufengpan input.err {
        background: red;
    }

    .yuliufengpan input.ok {
        background: #0f5717;
    }

    .peilv {
        padding: 2px 0 0 5px;
        position: absolute;
        background: #fff;
        top: 2px;
        right: 290px;
        border: 1px solid #000;
        height: 30px;
        width: 190px;
        line-height: 30px;
        border-radius: 10px;
    }

    .peilv input {
        width: 45px;
        text-align: center;
        color: #fff;
    }

    .peilv input.change {
        background: darkorange;
    }

    .peilv input.err {
        background: red;
    }

    .peilv input.ok {
        background: #0f5717;
    }

    .fanshuiSet {
        padding: 2px 0 0 5px;
        position: absolute;
        top: 2px;
        right: 135px;
        border: 1px solid #000;
        height: 30px;
        width: 135px;
        line-height: 30px;
        border-radius: 10px;
    }

    .fanshuiSet input {
        width: 45px;
        text-align: center;
        color: #fff;
    }

    .fanshuiSet input.change {
        background: darkorange;
    }

    .fanshuiSet input.err {
        background: red;
    }

    .fanshuiSet input.ok {
        background: #0f5717;
    }

    #selefocus {
        position: absolute;
        background: #fff;
        border: none;
        right: 3px;
        display: block;
        width: 1px;
        height: 0px;
        top: 3px;
        z-index: 1;
    }

    .dingwei {
        padding: 2px 0 0 5px;
        position: absolute;
        top: 2px;
        right: 10px;
        background: #fff;
        border: 1px solid #000;
        height: 30px;
        width: 260px;
        z-index: 100;
        border-radius: 10px;
    }

    .dingwei-ul {
        position: absolute;
        top: 2px;
        left: 50px;
        border: 1px solid #000;
        width: 160px;
        height: 25px;
    }

    .dwtitle {
        line-height: 30px;
    }

    .dingwei button {
        position: absolute;
        top: 1px;
        right: 1px;
    }

    .dingwei.change li {
        cursor: pointer;
    }

    .dingwei-ul li {
        display: block;
        text-align: center;
        background: #f2f2f2;
        line-height: 25px;
        width: 18px;
        height: 25px;
        border: 1px solid #000;
    }

    .dingwei-ul li.se {
        background: #0f5717 !important;
        color: #fff;
    }

    .dingwei.change li:hover {
        text-align: center;
        background: #31a924;
        color: #fff;
    }

    .jifen {
        position: relative;
        padding: 5px;
        border: 1px solid #000;
        height: 330px;
        border-radius: 0 0 10px 10px;
    }

    .jifenleftlist {
        padding: 5px;
        position: absolute;
        bottom: 5px;
        left: 5px;
        border: 1px solid #000;
        width: 280px;
        height: 280px;
        overflow-y: scroll;
        border-radius: 0 0 0 10px;
    }

    .jifenleftlist i {
        position: absolute;
        background: green;
        left: 0px;
        color: #fff;
        /* background-color: navajowhite; */
        display: none;
        width: 30px;
        font-size: 12px;
        line-height: 22px;
    }

    .jifenleftlist i.t,
    .jifenleftlist i.h {
        display: inline !important;
        text-align: center;
    }

    .jifenleftlist i.t {
        display: inline !important;
        background: blue !important;
        color: #fff;
    }

    .jifenleftlist i:hover {
        color: darkorange;
    }

    .jifenleftlist u {
        position: absolute;
        background: #f2f2f2;
        left: 18px;
        color: green;
        display: none;
    }

    .jifenleftlist u.t,
    .jifenleftlist u.h {
        display: inline !important;
    }

    .jifenleftlist u.t {
        display: inline !important;
        background: green !important;
        color: #fff;
    }

    .jifenleftlist u:hover {
        color: darkorange;
    }

    .jifenleftlist s {
        color: red;
        margin-left: 20px;
    }

    .jifenleftlist div {
        text-align: right;
        position: relative;
    }

    .jifenleftlist span {
        margin-right: 10px;
        width: 90px;
        text-align: center;
    }

    .jifenright {
        position: absolute;
        padding: 5px;
        width: 245px;
        height: 280px;
        bottom: 5px;
        right: 5px;
        border: 1px solid #000;
        border-radius: 0 0 10px 0;
    }

    .jifenright .headimg {
        position: absolute;
        width: 64px;
        height: 64px;
        right: 5px;
        top: 110px;
        border: 1px solid #000;
        border-radius: 4px;
        cursor: pointer;
    }

    .myheadimg {
        position: relative;
        width: 64px;
        height: 64px;
        right: -5px;
        top: 5px;
        border: 1px solid #000;
        border-radius: 4px;
    }

    .jifenright .create_user {
        position: absolute;
        right: 5px;
        top: 5px;
    }

    .jifenright .create_real {
        position: absolute;
        right: 75px;
        top: 5px;
    }

    .jifenright div {
        margin-bottom: 5px;
    }

    .jifenleftlist .se {
        background: #f5f5f5;
    }

    .jifenleftlist div:hover {
        background: #d5f3f7 !important;
    }

    .jifenmessage {
        color: red;
    }

    .jifenleftlist div {
        cursor: pointer;
    }

    .sxf {
        padding: 5px;
        border: 1px solid #000;
        height: 180px;
    }

    .sxf .sxftitle {
        font-weight: bold;
    }

    .sxf .sxflist {
        border: 1px solid #000;
        height: 87%;
        overflow-y: scroll;
    }

    .sxf .sxflist .sxfitem {
        position: relative;
        height: 30px;
        line-height: 30px;
    }

    .sxf .sxflist .sxfitem.se {
        background: #f5f5f5;
    }

    .sxf .sxflist .sxfitem:hover {
        background: #d5f3f7;
    }

    .sxf .sxflist .content {
        display: block;
        padding-left: 10px;
    }

    .sxf .sxflist .sxfitem i {
        font-weight: bold;
        color: darkblue;
        display: none;
        top: 0px;
        left: 0px;
    }

    .sxf .sxflist .sxfitem.tuo i {
        display: inline !important;
    }

    .sxf .sxflist .sxfbtns {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 120px;
    }

    .sxf .sxflist .sxfbtns span {
        display: block;
        position: absolute;
        width: 45px;
        top: 2px;
        height: 25px;
        line-height: 20px;
        padding: 2px 5px;
        cursor: pointer;
        background: #fff;
        z-index: 10;
        text-align: center;
    }

    .sxf .sxflist .sxfbtns span.ty {
        background: #c9efb5;
        color: #000;
        left: 0px;
        border: 1px solid #000;
    }

    .sxf .sxflist .sxfbtns span.ld {
        display: none;
        background: #fff;
        color: #000;
        opacity: 0.5;
        top: 0px;
        width: 99px;
        height: 28px;
        left: 0px;
        cursor: default;
        z-index: 20;
        filter: alpha(opacity=1);
        -moz-opacity: 0.01;
        -khtml-opacity: 0.01;
    }

    .sxf .sxflist .sxfbtns span.ty:hover {
        background: #31a924;
        color: #fff;
    }

    .sxf .sxflist .sxfbtns span.qx {
        background: #f2f2f2;
        color: #000;
        left: 60px;
        border: 1px solid #000;
    }

    .sxf .sxflist .sxfbtns span.qx:hover {
        background: #808080;
        color: #fff;
    }

    .black {
        background-color: yellow;
        color: black;
    }

    .fake,
    .zhui {
        background-color: rgb(255, 131, 71);
        color: white;
        margin-left: 3px;
        margin-right: 3px;
    }

    .uk-modal.uk-open {
        display: flex !important;
        align-items: center;
    }

    button {
        box-shadow: none;
        background: #ffffff;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        font-size: 14px;
        padding: 8px;
        height: 32px;
        line-height: 1;
        color: #606266;
    }

    .fanshuiSet2,
    .peilv2 {
        padding: 2px 0 0 5px;
        position: absolute;
        top: 4px;
        right: 135px;
        border: 1px solid #000;
        height: 30px;
        width: 135px;
        line-height: 30px;
        border-radius: 10px;
    }

    .fanshuiSet2 input.ok,
    .peilv2 input.ok {
        background: #0f5717;
        text-align: center;
        color: #fff;
    }

    .peilv,
    .fanshuiSet,
    .peilv2,
    .fanshuiSet2 {
        /*width: 100px;*/
        /*position: static;*/
        /*float: left;*/
        margin-left: 8px;
        height: 50px;
        line-height: 50px;
    }

    .fanshuiSet input,
    .peilv input,
    .peilv2 input,
    .fanshuiSet2 input {
        width: 35px;
    }

    .jifenleftlist i {
        position: inherit;
    }

    .selBtn {
        background: #409eff;
        color: #fff;
    }

    .uk-width-1-3,
    .uk-width-2-6 {
        width: 60%;
        padding-left: 20px;
        font-size: 12px;
    }

    .uk-width-2-3,
    .uk-width-2-6 {
        width: 33%;
    }

    #kaipanstatus.sed {
        color: #909399 !important;
        border-color: #909399 !important;
    }

    .el-overlay {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2000;
        height: 100%;
        background-color: #00000080;
        overflow: auto;
    }

    .main {
        display: flex;
        justify-content: space-around;
        padding-bottom: 5px;
    }

    #codelogin,
    #xiazhuban,
    .rightframe,
    #codelogin .logininp {
        position: inherit;
    }

    #codelogin .logininp {
        margin: 5px;
        /* height: 275px; */
        height: auto;
    }

    #codelogin .logininp b {
        color: inherit;
    }

    .alertBox {
        width: 920px;
        margin: 4px auto;
        position: relative;
    }

    .topframe {
        width: 920px;
        height: auto;
    }

    #codelogin {
        display: block;
        height: 285px;
    }

    #xiazhuban {
        overflow: hidden;
        height: calc(100% - 300px);
        margin-top: 8px;
    }

    #wangpan {
        height: auto;
        width: 565px;
        position: static;
        margin-top: 0;
        border: none;
    }

    #xiazhubanlist {
        border: none;
        border-top: 1px solid #000;
    }

    .rightframe {
        width: 590px;
    }

    .functions {
        border: none;
        border-top: 1px solid #000;
    }

    #el-id-7854-9 .uk-width-1-3 {
        width: 45%;
        text-align: right;
    }

    #el-id-7854-9 .uk-width-2-3 {
        width: 54%;
    }

    .el-dialog {
        width: 100% !important;
        min-height: 100vh;
        margin: 0 !important;
    }

    .el-dialog__wrapper {
        width: 100%;
        height: 100%;
    }

    .uk-modal-footer {
        margin: 0 -20px -20px -20px;
        border-top: none;
        background: none;
    }

    .js-modal-confirm {
        margin-right: 10px;
    }

    .layui-layer-title {
        border-bottom: none;
    }

    /* button, */
    input,
    textarea {
        line-height: 24px !important;
        /* font: initial; */
        /* font-size: 100%; */
    }

    .el-message-box {
        max-width: 100%;
    }

    .LeftScore {
        color: black;
        font-size: 16px;
        font-weight: bold;
    }

    .tshow {
        font-size: 16px;
    }

    .thide {
        font-size: 16px;
    }

    .Cmd {
        color: black;
        font-size: 16px;
        background-color: yellow;
    }

    .DownScore {
        color: white;
        background-color: green;
    }

    .UpScore {
        color: white;
        background-color: red;
    }

    .mingxiHide {
        display: none;
    }

    .ToHide {
        display: none;
    }

    .ToShow {
        display: block;
    }

    .dates span,
    .types span {
        margin-left: 10px;
        cursor: pointer;
        position: relative;
    }

    .dates span.sele,
    .types span.sele {
        font-weight: 500;
    }

    .dates span.sele:after,
    .types span.sele:after {
        border-bottom: 3px solid #ee0a24;
        position: absolute;
        content: '';
        width: 40px;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
    }

    .types span.sele:after {
        border-bottom: 3px solid #0af;
    }

    .infoitem {
        border-radius: 4px;
        border: 1px solid #000;
        background: #dff4ff;
        /* background: #b2b2de; */
        font-size: 12px;
        margin: 2px;
        padding: 5px;
    }

    .infoitem.chi {
        background: #b2b2de;
    }

    .infoitem.sele {
        border: 2px solid orange;
    }

    .liu {
        border: 2px solid orange;
    }

    .infoitem.is_excep {
        background: red;
        color: #fff;
    }

    .infoitem.is_excep .infoitem_row {
        background: #fcc9c9 !important;
        color: #000000 !important;
    }

    .infoitem.is_excep .all_fanshui {
        color: #ffffff !important;
    }

    .infoitem.is_tuo {
        background: #b2b2de;
    }

    .infolist .item_top span {
        font-weight: bold;
        margin: 2px;
    }

    .infolist .infoitem_row {
        position: relative;
        padding: 10px;
        border-radius: 4px;
        border: 1px solid #000;
    }

    .infoitem_row.type1 {
        background: #efefef;
    }

    .infolist .infoitem_row span {
        margin-right: 10px;
    }

    .infolist .infoitem_row span.tuo {
        position: absolute;
        top: -7px;
        left: 55px;
        background: darkblue;
        display: block;
        width: 20px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        color: #fff;
    }

    .infolist .infoitem_row .rowcontent {
        padding: 2px;
        background: #808080;
        color: #fff;
    }

    .infolist .infoitem_row .rowcontent.sf {
        background: red;
        color: #fff;
    }

    .infolist .infoitem_row .rowcontent.xf {
        background: green;
        color: #fff;
    }

    .infolist .infoitem_row .fanshui {
        color: red;
        font-size: 14px;
    }

    .infolist .infoitem_row .rowchange.win {
        color: red;
    }

    .infolist .infoitem_row .rowchange.lose {
        color: green;
    }

    .infolist .infoitem_row .rowscore {
        font-weight: bold;
    }

    .infolist .profit_loss.changescore:before {
        content: '改分';
        color: #ffffff;
        background: red;
        font-weight: bold;
    }

    .infolist .all_fanshui {
        color: red;
        display: none;
        font-weight: bold;
    }

    .item_detail {}

    .tt1 {
        margin-top: 5px;
        font-size: 16px;
    }

    .custom-block.tip {
        padding: 8px 16px;
        background-color: #409eff1a;
        border-radius: 4px;
        border-left: 5px solid #409eff;
        margin: 20px 0;
    }

    .custom-block .custom-block-title {
        font-weight: 700;
        margin-bottom: 8px;
        font-size: 16px;
    }

    body {
        font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB, Microsoft Yahei, sans-serif;
        font-size: 14px;
    }

    .el-checkbox {
        align-items: center;
        display: inline-flex !important;
        height: 32px;
    }
</style>
